// src/pages/admin/Utilizadores.js
import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function Utilizadores() {
  const { showAlert } = useAlert();
  const { temPermissao } = useAuth();

  const [data, setData] = useState([]);

  const carregar = async () => {
    const [payload, err] = await handleApi(api.post("UtilizadoresAcessos/SelUtilizadores", {}));
    if (err) {
      showAlert(err, "error");
      return;
    }
    setData(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    (async () => {
      await carregar();
    })();
  }, []);

  // ---------- ADD ----------
  const [openAdd, setOpenAdd] = useState(false);

  const [novo, setNovo] = useState({
    designacao: "",
    // campos gerais
    refvendedor: "",
    dataadmissao: "", // "YYYY-MM-DD"
    telemovel: "",
    observacoes: "",
    fator_merito_pessoal: "0",
    // controlo de utilizador
    eUtilizador: false, // mostra/obriga credenciais apenas se true
    username: "",
    pwd: "",
    email: "@jfbebidas.com",
    limpeza_viatura_default: 0,
    ajuda_armazem_default: 0,
  });

  // ---------- EDIT ----------
  const [openEdit, setOpenEdit] = useState(false);
  const [sel, setSel] = useState(null);
  const [selIsUser, setSelIsUser] = useState(true);

  const [openCaracteristicas, setOpenCaracteristicas] = useState(false);
  const [caracteristicasUtilizador, setCaracteristicasUtilizador] = useState([]);
  const [loadingCaracteristicas, setLoadingCaracteristicas] = useState(false);

  // Dialog de confirmação para ativar/inativar
  const [openConfirm, setOpenConfirm] = useState(false);
  const [targetUser, setTargetUser] = useState(null);
  const [novoEstado, setNovoEstado] = useState(null); // 0 ou 1

  const capitalizeWords = (str) =>
    (str ?? "")
      .trim()
      .toLowerCase()
      .replace(/(?:^|\s)\S/g, (c) => c.toUpperCase());

  const carregarCaracteristicasUtilizador = async (idutilizador) => {
    if (!idutilizador) return;

    setLoadingCaracteristicas(true);

    const [payload, err] = await handleApi(
      api.post("UtilizadoresAcessos/SelUtilizadorCaracteristicasItens", { idutilizador })
    );

    if (err) {
      setLoadingCaracteristicas(false);
      showAlert(err, "error");
      return;
    }

    setCaracteristicasUtilizador(Array.isArray(payload) ? payload : []);
    setLoadingCaracteristicas(false);
  };

  const totalCaracteristicasSelecionadas = caracteristicasUtilizador
    .filter((x) => Number(x?.selecionada) === 1 && Number(x?.inativa || 0) === 0)
    .reduce((acc, x) => acc + Number(x?.valor || 0), 0);

  const gravarCaracteristicasUtilizador = async () => {
    if (!sel?.id) return;

    if (Number(totalCaracteristicasSelecionadas.toFixed(4)) > 1) {
      showAlert("O total das caraterísticas selecionadas não pode ser superior a 1.", "error");
      return;
    }

    const idsCaracteristicas = caracteristicasUtilizador
      .filter((x) => Number(x?.selecionada) === 1)
      .map((x) => Number(x.id))
      .filter((x) => x > 0);

    const [payload, err, meta] = await handleApi(
      api.post("UtilizadoresAcessos/UpdUtilizadorCaracteristicasItens", {
        idutilizador: sel.id,
        idsCaracteristicas,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    if (meta?.message) showAlert(meta.message, meta.severity || "success");

    setSel((p) => ({
      ...p,
      fator_merito_pessoal: String(
        payload?.fator_merito_pessoal ?? totalCaracteristicasSelecionadas
      ),
    }));

    setOpenCaracteristicas(false);
    await carregar();
  };

  // ------------------- Colunas + Tabela -------------------

  const rowActions = useMemo(
    () => [
      {
        id: "editar",
        icon: <EditIcon fontSize="small" />,
        tooltip: "Editar",
        color: "default",
        visible: () => temPermissao("Menu Administração", "u"),
        onClick: (u) => {
          setSel({
            ...u,
            pwd: "",
            refvendedor: u.refvendedor || "",
            dataadmissao: u.dataadmissao || "",
            telemovel: u.telemovel || "",
            observacoes: u.observacoes || "",
            limpeza_viatura_default: Number(u.limpeza_viatura_default || 0),
            ajuda_armazem_default: Number(u.ajuda_armazem_default || 0),
            fator_merito_pessoal:
              u.fator_merito_pessoal === null || u.fator_merito_pessoal === undefined
                ? "0"
                : String(u.fator_merito_pessoal),
          });

          setSelIsUser(!!(u?.username || u?.email));
          setOpenEdit(true);
        },
      },

      {
        id: "estado",
        icon: (u) =>
          u.inativo === 1 ? <CheckCircleIcon fontSize="small" /> : <BlockIcon fontSize="small" />,
        tooltip: (u) => (u.inativo === 1 ? "Reativar" : "Inativar"),
        color: (u) => (u.inativo === 1 ? "success" : "error"),
        visible: () => temPermissao("Menu Administração", "d"),
        onClick: (u) => {
          setTargetUser(u);
          setNovoEstado(u.inativo === 1 ? 0 : 1);
          setOpenConfirm(true);
        },
      },
    ],
    [temPermissao, showAlert]
  );

  const columns = useMemo(
    () => [
      { Header: "Designação", accessor: "designacao" },
      { Header: "Username", accessor: "username" },
      { Header: "Email", accessor: "email" },
      { Header: "Ref. Vendedor", accessor: "refvendedor" },
      {
        Header: "Fator Mérito",
        accessor: "fator_merito_pessoal",
        Cell: ({ value }) => Number(value || 0).toFixed(2),
      },
      {
        Header: "Ativo",
        accessor: "inativo",
        Cell: ({ value }) =>
          value === 0 ? (
            <CheckCircleIcon style={{ color: "black" }} fontSize="small" />
          ) : (
            <BlockIcon style={{ color: "black" }} fontSize="small" />
          ),
      },
    ],
    [temPermissao]
  );

  // ---------- Ações ----------
  const inserir = async () => {
    if (!novo.designacao) {
      showAlert("Preenche o Nome.", "warning");
      return;
    }
    if (novo.eUtilizador && (!novo.username || !novo.pwd || !novo.email)) {
      showAlert("Para utilizador da app, preenche Username, Password e Email.", "warning");
      return;
    }

    const body = {
      designacao: novo.designacao,
      username: novo.eUtilizador ? novo.username : null,
      pwd: novo.eUtilizador ? novo.pwd : null,
      email: novo.eUtilizador ? novo.email : null,
      refvendedor: novo.refvendedor || null,
      dataadmissao: novo.dataadmissao || null,
      telemovel: novo.telemovel || null,
      observacoes: novo.observacoes || null,
      limpeza_viatura_default: Number(novo.limpeza_viatura_default || 0),
      ajuda_armazem_default: Number(novo.ajuda_armazem_default || 0),
    };

    const [_, err, meta] = await handleApi(api.post("UtilizadoresAcessos/InsUtilizador", body));
    if (err) return showAlert(err, "error");
    if (meta?.message) showAlert(meta.message, meta.severity || "success");

    await carregar();
    setOpenAdd(false);
    setNovo({
      designacao: "",
      refvendedor: "",
      dataadmissao: "",
      telemovel: "",
      observacoes: "",
      fator_merito_pessoal: "0",
      eUtilizador: true,
      username: "",
      pwd: "",
      email: "@jfbebidas.com",
    });
  };

  const gravarEdicao = async () => {
    const body = {
      id: sel.id,
      designacao: sel.designacao,
      username: selIsUser ? sel.username : null,
      pwd: selIsUser ? sel.pwd : null, // se vazio, backend mantém
      email: selIsUser ? sel.email : null,
      refvendedor: sel.refvendedor || null,
      dataadmissao: sel.dataadmissao || null,
      telemovel: sel.telemovel || null,
      observacoes: sel.observacoes || null,
      limpeza_viatura_default: Number(sel.limpeza_viatura_default || 0),
      ajuda_armazem_default: Number(sel.ajuda_armazem_default || 0),
    };

    const [_, err, meta] = await handleApi(api.post("UtilizadoresAcessos/UpdUtilizador", body));
    if (err) return showAlert(err, "error");
    if (meta?.message) showAlert(meta.message, meta.severity || "success");
    await carregar();
    setOpenEdit(false);
  };

  const confirmarEstado = async () => {
    if (!targetUser) return setOpenConfirm(false);
    const [_, err, meta] = await handleApi(
      api.post("UtilizadoresAcessos/AtualizarEstadoUtilizador", {
        id: targetUser.id,
        inativo: novoEstado,
      })
    );
    if (err) showAlert(err, "error");
    else if (meta?.message) showAlert(meta.message, meta.severity || "success");
    await carregar();
    setOpenConfirm(false);
    setTargetUser(null);
    setNovoEstado(null);
  };

  // ---------- UI ----------
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageHeader />

      <MDBox pt={1}>
        <ProjectTable
          tableKey="utilizadores"
          version="v1"
          columns={columns}
          data={data}
          rowActions={rowActions}
          toolbarActions={[
            {
              id: "novo-funcionario",
              label: "Novo Funcionário",
              color: "success",
              disabled: !temPermissao("Menu Administração", "w"),
              onClick: () => setOpenAdd(true),
            },
          ]}
          minWidth={900}
          maxHeight="68vh"
          emptyMessage="Sem utilizadores para apresentar."
          actionsPosition="left"
        />
      </MDBox>

      {/* Editar */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Editar Utilizador</DialogTitle>
        <DialogContent>
          <MDBox display="grid" gap={1.25} mt={0.5}>
            <MDInput
              label="Designação"
              value={sel?.designacao || ""}
              onChange={(e) => setSel((p) => ({ ...p, designacao: e.target.value }))}
              onBlur={(e) => setSel((p) => ({ ...p, designacao: capitalizeWords(e.target.value) }))}
              fullWidth
            />
            <MDInput
              label="Ref. Vendedor"
              value={sel?.refvendedor || ""}
              onChange={(e) => setSel((p) => ({ ...p, refvendedor: e.target.value }))}
              fullWidth
            />
            <MDInput
              label="Data de admissão"
              type="date"
              value={sel?.dataadmissao || ""}
              onChange={(e) => setSel((p) => ({ ...p, dataadmissao: e.target.value }))}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
            <MDInput
              label="Telemóvel"
              value={sel?.telemovel || ""}
              onChange={(e) => setSel((p) => ({ ...p, telemovel: e.target.value }))}
              fullWidth
            />
            <MDInput
              label="Observações"
              value={sel?.observacoes || ""}
              onChange={(e) => setSel((p) => ({ ...p, observacoes: e.target.value }))}
              multiline
              rows={2}
              fullWidth
            />

            <MDInput
              label="Fator de Mérito Pessoal"
              value={sel?.fator_merito_pessoal || "0"}
              fullWidth
              disabled
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(sel?.limpeza_viatura_default || 0) === 1}
                  onChange={(e) =>
                    setSel((p) => ({ ...p, limpeza_viatura_default: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Limpeza da viatura por defeito"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(sel?.ajuda_armazem_default || 0) === 1}
                  onChange={(e) =>
                    setSel((p) => ({ ...p, ajuda_armazem_default: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Ajuda no armazém por defeito"
            />

            <MDButton
              color="info"
              variant="outlined"
              onClick={async () => {
                await carregarCaracteristicasUtilizador(sel?.id);
                setOpenCaracteristicas(true);
              }}
              disabled={!sel?.id}
            >
              CARATERÍSTICAS DO FUNCIONÁRIO
            </MDButton>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selIsUser}
                  onChange={(e) => setSelIsUser(e.target.checked)}
                  size="small"
                />
              }
              label="É utilizador da app"
            />
            {selIsUser && (
              <>
                <MDInput
                  label="Username"
                  value={sel?.username || ""}
                  onChange={(e) => setSel((p) => ({ ...p, username: e.target.value }))}
                  onBlur={(e) =>
                    setSel((p) => ({ ...p, username: e.target.value.trim().toLowerCase() }))
                  }
                  fullWidth
                />
                <MDInput
                  label="Password (deixar vazia para manter)"
                  type="password"
                  value={sel?.pwd || ""}
                  onChange={(e) => setSel((p) => ({ ...p, pwd: e.target.value }))}
                  fullWidth
                />
                <MDInput
                  label="Email"
                  type="email"
                  value={sel?.email || ""}
                  onChange={(e) => setSel((p) => ({ ...p, email: e.target.value }))}
                  fullWidth
                />
              </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenEdit(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={gravarEdicao} color="success">
            Guardar
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* Adicionar */}
      <Dialog open={openAdd} onClose={() => setOpenAdd(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Adicionar Novo Utilizador ou Funcionário</DialogTitle>
        <DialogContent component="form" autoComplete="off">
          <MDBox display="grid" gap={1.25} mt={0.5}>
            <MDInput
              label="Nome"
              value={novo.designacao}
              onChange={(e) => setNovo((p) => ({ ...p, designacao: e.target.value }))}
              onBlur={(e) =>
                setNovo((p) => ({ ...p, designacao: capitalizeWords(e.target.value) }))
              }
              fullWidth
            />

            <MDInput
              label="Ref. Vendedor"
              value={novo.refvendedor || ""}
              onChange={(e) => setNovo((p) => ({ ...p, refvendedor: e.target.value }))}
              fullWidth
            />

            <TextField
              label="Data de admissão"
              type="date"
              value={novo.dataadmissao || ""}
              onChange={(e) => setNovo((p) => ({ ...p, dataadmissao: e.target.value }))}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />

            <MDInput
              label="Telemóvel"
              value={novo.telemovel || ""}
              onChange={(e) => setNovo((p) => ({ ...p, telemovel: e.target.value }))}
              fullWidth
            />

            <MDInput
              label="Observações"
              value={novo.observacoes || ""}
              onChange={(e) => setNovo((p) => ({ ...p, observacoes: e.target.value }))}
              multiline
              rows={2}
              fullWidth
            />

            <MDInput
              label="Fator de Mérito Pessoal"
              value={novo.fator_merito_pessoal || "0"}
              fullWidth
              disabled
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(novo?.limpeza_viatura_default || 0) === 1}
                  onChange={(e) =>
                    setNovo((p) => ({ ...p, limpeza_viatura_default: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Limpeza da viatura por defeito"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={Number(novo?.ajuda_armazem_default || 0) === 1}
                  onChange={(e) =>
                    setNovo((p) => ({ ...p, ajuda_armazem_default: e.target.checked ? 1 : 0 }))
                  }
                  size="small"
                />
              }
              label="Ajuda no armazém por defeito"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={novo.eUtilizador}
                  onChange={(e) =>
                    setNovo((p) => ({
                      ...p,
                      eUtilizador: e.target.checked,
                      username: e.target.checked ? "" : p.username,
                      pwd: e.target.checked ? "" : p.pwd,
                      email: e.target.checked ? "@jfbebidas.com" : p.email,
                    }))
                  }
                  size="small"
                />
              }
              label="É utilizador da app"
            />

            {novo.eUtilizador && (
              <>
                <MDInput
                  label="Username"
                  value={novo.username}
                  onChange={(e) => setNovo((p) => ({ ...p, username: e.target.value }))}
                  onBlur={(e) =>
                    setNovo((p) => ({ ...p, username: e.target.value.trim().toLowerCase() }))
                  }
                  fullWidth
                  inputProps={{
                    autoComplete: "username",
                    autoCapitalize: "none",
                    autoCorrect: "off",
                    spellCheck: false,
                  }}
                />
                <MDInput
                  label="Password"
                  type="password"
                  value={novo.pwd}
                  onChange={(e) => setNovo((p) => ({ ...p, pwd: e.target.value }))}
                  fullWidth
                />
                <MDInput
                  label="Email"
                  type="email"
                  value={novo.email}
                  onChange={(e) => setNovo((p) => ({ ...p, email: e.target.value }))}
                  fullWidth
                  inputProps={{
                    autoComplete: "new-password",
                    autoCapitalize: "none",
                    autoCorrect: "off",
                    spellCheck: false,
                  }}
                />
              </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenAdd(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={inserir} color="success">
            Inserir
          </MDButton>
        </DialogActions>
      </Dialog>

      {/* CONFIRMAR ATIVAR/INATIVAR */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          {novoEstado === 1 ? "Inativar utilizador" : "Reativar utilizador"}
        </DialogTitle>
        <DialogContent>
          {novoEstado === 1 ? "Inativar" : "Reativar"} o utilizador{" "}
          <strong>{targetUser?.designacao ?? ""}</strong>?
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton onClick={confirmarEstado} color={novoEstado === 1 ? "error" : "success"}>
            {novoEstado === 1 ? "Inativar" : "Reativar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCaracteristicas}
        onClose={() => setOpenCaracteristicas(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Caraterísticas do Funcionário</DialogTitle>
        <DialogContent>
          <MDBox display="grid" gap={1.25} mt={0.5}>
            <MDBox
              sx={{
                border: "1px solid rgba(0,0,0,0.12)",
                borderRadius: 2,
                px: 1.5,
                py: 1,
                backgroundColor:
                  Number(totalCaracteristicasSelecionadas.toFixed(2)) >= 1 ? "#e8f5e9" : "#fff8e1",
              }}
            >
              <MDBox
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ fontSize: 14, fontWeight: 700, color: "#344767" }}
              >
                <span>Fator de Mérito Pessoal</span>
                <span>{totalCaracteristicasSelecionadas.toFixed(2)}</span>
              </MDBox>
            </MDBox>

            {loadingCaracteristicas ? (
              <div>A carregar...</div>
            ) : (
              caracteristicasUtilizador.map((item) => (
                <MDBox
                  key={item.id}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    border: "1px solid rgba(0,0,0,0.12)",
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.75,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Number(item?.selecionada || 0) === 1}
                        onChange={(e) =>
                          setCaracteristicasUtilizador((prev) =>
                            prev.map((x) =>
                              Number(x.id) === Number(item.id)
                                ? { ...x, selecionada: e.target.checked ? 1 : 0 }
                                : x
                            )
                          )
                        }
                        size="small"
                        disabled={Number(item?.inativa || 0) === 1}
                      />
                    }
                    label={item.designacao}
                    sx={{ mr: 0 }}
                  />

                  <MDBox
                    sx={{
                      minWidth: 56,
                      textAlign: "right",
                      fontSize: 13,
                      fontWeight: 600,
                      color: "#344767",
                    }}
                  >
                    {Number(item.valor || 0).toFixed(2)}
                  </MDBox>
                </MDBox>
              ))
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenCaracteristicas(false)} color="secondary">
            Cancelar
          </MDButton>
          <MDButton
            onClick={gravarCaracteristicasUtilizador}
            color="success"
            disabled={Number(totalCaracteristicasSelecionadas.toFixed(4)) > 1}
          >
            Gravar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
